module.exports = require("@graphistry/falcor-path-utils/lib/collapse");


//////////////////
// WEBPACK FOOTER
// external "@graphistry/falcor-path-utils/lib/collapse"
// module id = 55
// module chunks = 0